<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "Confirm-Order",
        "hide-footer": "",
        centered: "",
        size: "sm",
      },
      on: {
        show: _vm.handleModalShow,
        hide: function ($event) {
          return _vm.onModalHidden(false)
        },
      },
      model: {
        value: _vm.modalVisible,
        callback: function ($$v) {
          _vm.modalVisible = $$v
        },
        expression: "modalVisible",
      },
    },
    [
      _c(
        "div",
        { staticClass: "text-center mb-1 head-top-15" },
        [
          _vm.documentType === "image"
            ? _c("b-img", {
                staticClass: "camera",
                staticStyle: { "max-width": "100%" },
                attrs: { src: _vm.url, alt: "pic image" },
                on: { load: _vm.handleLoad, error: _vm.handleLoad },
              })
            : _vm._e(),
          _vm.documentType === "pdf"
            ? _c("iframe", {
                staticStyle: { "max-width": "100%" },
                attrs: { src: _vm.url, width: "100%", height: "500px" },
                on: { load: _vm.handleLoad, error: _vm.handleLoad },
              })
            : _vm._e(),
          _vm.documentType === "video"
            ? _c("VideoPreview", {
                staticStyle: { "max-width": "100%" },
                attrs: {
                  videoUrl: _vm.url,
                  documentType: "video",
                  isLoading: true,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/layouts/components/ImagePreview.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import layouts_components_VideoPreview_vue from '@/layouts/components/VideoPreview.vue';
import * as vuex from 'vuex';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




export default ({
  render,
  staticRenderFns,
  components: {
    BModal: bootstrapvue["BModal"],
    BButton: bootstrapvue["BButton"],
    BImg: bootstrapvue["BImg"],
    VideoPreview: layouts_components_VideoPreview_vue
  },
  data() {
    return {
      modalVisible: this.showPop
    };
  },
  watch: {
    showPop(newValue) {
      this.modalVisible = newValue;
    }
  },
  computed: {
    ...vuex.mapState("user", ["isLoadingArray"])
  },
  mounted() {},
  methods: {
    ...vuex.mapMutations("user", ["setLoadingArray"]),
    handleModalShow() {
      if (this.documentType !== "pdf") {
        this.isLoadingArray.push("1");
        this.setLoadingArray(this.isLoadingArray);
      }
    },
    handleLoad() {
      this.isLoadingArray.pop();
      this.setLoadingArray(this.isLoadingArray);
    }
  },
  props: {
    showPop: {
      type: Boolean,
      isRequired: false,
      default: false
    },
    onModalHidden: {
      type: Function,
      isRequired: true,
      default: () => {}
    },
    url: {
      type: String,
      isRequired: true,
      default: ""
    },
    documentType: {
      type: String,
      default: ""
    }
  }
});

//# sourceURL=webpack:///./src/layouts/components/ImagePreview.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.camera {
  width: 100%;
  height: 100%;
}
</style>
